import React, { Component } from "react";
import Helper from "../../utilities/Helper";
import { withIntl } from "../../../common/lang";

class Diabetes extends Component {
  componentDidUpdate = (prv) => {
    if (prv.diabetes !== this.props.diabetes) {
      this.props.setSelected(
        "diabetes",
        this.checkDiabetes(this.props.diabetes)
      );
    }
  };

  handleDiabetesInputChange = (event) => {
    this.props.handleOnChange(event);
  };

  diabetesHelper = () => {
    const { formatMessage } = this.props.intl;
    if (this.checkDiabetes(this.props.diabetes)) {
      return <Helper text={formatMessage({ id: "form.diabetes.helper" })} />;
    }
  };

  checkDiabetes = (diabetes) => {
    if (diabetes === "yes") {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="col-12 element-group">
        <div className="row">
          <div className="col-12">
            <div className="search-label">
              {formatMessage({ id: "form.diabetes" })}
            </div>
          </div>
          <div className="col-12">
            <select
              className="form-control search-select search-select-md"
              name="diabetes"
              onChange={this.handleDiabetesInputChange}
              value={this.props.diabetes}
            >
              <option value="">
                {formatMessage({ id: "ui.label.select" })}
              </option>
              <option value="yes">{formatMessage({ id: "form.yes" })}</option>
              <option value="no">{formatMessage({ id: "form.no" })}</option>
              <option value="notsure">
                {formatMessage({ id: "form.notSure" })}
              </option>
            </select>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="helper-text">{this.diabetesHelper()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withIntl(Diabetes);
